<div class="container-fluid mt-3 text-grey">
    <div>
        <h4>
            SyncHPC License Details : 
        </h4>
    </div>
    <div *ngIf="!isLoading && !error" class="table-container">
        <div class="table-wrapper">
            <table class="table table-custom">
            <tbody>
                <tr *ngFor="let key of objectKeys">
                <td class="col-label">{{ formatLabel(key) }}</td>
                <td class="col-value">
                    <ng-container [ngSwitch]="true">
                    <span *ngSwitchDefault>
                        {{ getValue(info[key]) }}
                    </span>
                    </ng-container>
                </td>
                </tr>
            </tbody>
            </table>
        </div>
    </div>


    <ngx-spinner
        bdColor="rgba(0,0,0,0)"
        size="default"
        zIndex="1"
        color="var(--s-primary-color)"
        type="ball-spin"
        [fullScreen]="false"
        name="keySpinner"
        >
        <p class="pleaseWait">Please wait ...</p>
    </ngx-spinner>

    <div *ngIf="!isLoading && !error && (!info || objectKeys.length === 0)" 
        class="alert alert-info" role="alert">
        No information available
    </div>
</div>
